// extracted by mini-css-extract-plugin
export var actions = "_sr-4";
export var item = "_sr-1";
export var price = "_sr-3";
export var quantity = "_sr-2";
export var table = "_sr-0";